TS.ns('WL');

WL.securityViewModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;
        me.parent(config); 

        var authorizationMatrixRead = me.getDomainProperty('AuthorizationMatrixRead');

        if (authorizationMatrixRead) {
            authorizationMatrixRead.on('cellBeginEdit', me.onAuthorizationSelectedItemChanged);
            me.MatrixReadRefineVisible = ko.computed(function () {
                if (authorizationMatrixRead.SelectedItem() == null)
                    return false;
                return authorizationMatrixRead.SelectedItem().Refine();
            });

            var cat = authorizationMatrixRead.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'RefineSecurity';
            newCmd['Text'] = me.RefineSecurityCommandText();
            newCmd['handler'] = '_refineSecurity';
            newCmd['IconCode'] = 'ellipsis-v';
            newCmd.InternalVisible = me.MatrixReadRefineVisible;

            if (!me.ReadOnly())
                cat.push(newCmd);

            me.MatrixReadUnrefineVisible = ko.computed(function () {
                if (authorizationMatrixRead.SelectedItem() == null)
                    return false;
                return authorizationMatrixRead.SelectedItem().ReadRefined();
            });

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'UnrefineSecurity';
            newCmd['Text'] = me.UnrefineSecurityCommandText();
            newCmd['handler'] = '_unrefineSecurity';
            newCmd['IconCode'] = 'ellipsis-v';
            newCmd.InternalVisible = me.MatrixReadUnrefineVisible;

            if (!me.ReadOnly())
                cat.push(newCmd);

            me.MatrixReadAuthorizeAllVisible = ko.computed(function () {
                if (authorizationMatrixRead.SelectedItem() == null)
                    return false;
                if (authorizationMatrixRead.SelectedItem().ReadRefined())
                    return false;
                var visible = false;
                var array = $.map(authorizationMatrixRead.SelectedItem(), function (value, index) {
                    return [value];
                });
                var x = Object.keys(authorizationMatrixRead.SelectedItem());
                $.each(x, function (index, value) {
                    if (value.indexOf("UG") !== -1) {
                        if (!array[index]()) {
                            visible = true;
                        }
                    }
                });
                return visible;
            });

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'AuthorizeAllSecurityCommand';
            newCmd['Text'] = me.AuthorizeAllSecurityCommandText();
            newCmd['handler'] = '_authorizeAllSecurity';
            newCmd['IconCode'] = 'ellipsis-v';
            newCmd.InternalVisible = me.MatrixReadAuthorizeAllVisible;

            if (!me.ReadOnly())
                cat.push(newCmd);

            me.MatrixReadUnauthorizeAllVisible = ko.computed(function () {
                if (authorizationMatrixRead.SelectedItem() == null)
                    return false;
                if (authorizationMatrixRead.SelectedItem().ReadRefined())
                    return false;
                var visible = false;
                var array = $.map(authorizationMatrixRead.SelectedItem(), function (value, index) {
                    return [value];
                });
                var x = Object.keys(authorizationMatrixRead.SelectedItem());
                $.each(x, function (index, value) {
                    if (value.indexOf("UG") !== -1) {
                        if (array[index]()) {
                            visible = true;
                        }
                    }
                });
                return visible;
            });

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'UnauthorizeAllSecurityCommand';
            newCmd['Text'] = me.UnauthorizeAllSecurityCommandText();
            newCmd['handler'] = '_unauthorizeAllSecurity';
            newCmd['IconCode'] = 'ellipsis-v';
            newCmd.InternalVisible = me.MatrixReadUnauthorizeAllVisible;

            if (!me.ReadOnly())
                cat.push(newCmd);
        }

        me.colorRefinedAuthorization();


    },

    colorRefinedAuthorization: function () {
        var me = this;

        var authorizationMatrixRead = me.getDomainProperty('AuthorizationMatrixRead');
        if (authorizationMatrixRead) {
            authorizationMatrixRead.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.content.children("table").children("tbody").children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        if (dataItem.ReadRefined == true) {
                            row.addClass("security_blue_row");
                        }
                    }
                }
            }
        }
    },

    _refineSecurity: function () {
        var me = this;
        me.performServerCommand({
            cmd: 'RefineSecurity',
            submitModel: true,
            blockUI: true,
            callback: function () { me.colorRefinedAuthorization(); }
        });
    },

    _unrefineSecurity: function () {
        var me = this;
        onYes = function () {
            me.performServerCommand({
                cmd: 'UnrefineSecurity',
                submitModel: true,
                blockUI: true,
                callback: function () { me.colorRefinedAuthorization(); }
            });
        }

        TS.MsgBox.confirm(null, me.UnrefineSecurityCommandValidationText(), null, onYes);
    },

    _authorizeAllSecurity: function () {
        var me = this;
        me.performServerCommand({
            cmd: 'AuthorizeAllSecurity',
            submitModel: true,
            blockUI: true
        });
    },

    _unauthorizeAllSecurity: function () {
        var me = this;
        me.performServerCommand({
            cmd: 'UnauthorizeAllSecurity',
            submitModel: true,
            blockUI: true
        });
    },

    onAuthorizationSelectedItemChanged: function (e) {
        var me = this,
            owner = me._Domain;

        owner.AuthorizationDescription(e.record.Description());

        if (e.fieldName == "AuthorizationContextTypeName" || e.fieldName == "Name")
            e.preventDefault();
    } 
});